import { Box, Flex, Text } from '@chakra-ui/react'
import { useDoubleStore } from '@/context/DoubleProvider'
import { typeSafeObjectEntries } from '@/helpers/typeSafeObjectEntries'
import { DoubleField } from '../atoms/DoubleField'
import { DoubleColor } from '@/__generated__/graphql'
import { useTranslation } from 'next-i18next/pages'

export type DoubleStatistics = {
  history: Array<DoubleColor>
  statistics: Record<DoubleColor, number>
}

export const DoubleLastRolls = () => {
  const lastColors = useDoubleStore((x) => x.lastColors)

  if (!lastColors) {
    return null
  }

  return (
    <Flex flexDir={'column'} alignItems={'end'} zIndex={50}>
      <DoubleLastRollsStats statistics={lastColors.statistics} />
      <DoubleLastRollsList history={lastColors.history} />
    </Flex>
  )
}

const DoubleLastRollsList = ({ history }: { history: Array<DoubleColor> }) => {
  return (
    <Flex
      display={{ base: 'none', md: 'flex' }}
      p={1.5}
      gap={1}
      rounded={'lg'}
      justifyContent={'end'}
      border={'1px solid'}
      borderColor={'whiteAlpha.100'}
    >
      {history.slice(0, -1).map((type, index) => (
        <DoubleField key={index} boxSize={5} type={type} />
      ))}
      <Box w={2.5} h={5} overflow={'hidden'}>
        <DoubleField boxSize={5} type={history.at(-1)!} />
      </Box>
    </Flex>
  )
}

const DoubleLastRollsStats = ({ statistics }: { statistics: Record<DoubleColor, number> }) => {
  const { t } = useTranslation()
  return (
    <Box mb={2} display={{ base: 'none', md: 'block' }}>
      <Flex alignItems={'center'} gap={2} fontSize={'sm'} fontWeight={700}>
        <Text mr={1} fontSize={'xs'}>
          {t('common.last-100-rolls')}
        </Text>

        {typeSafeObjectEntries(statistics).map(([type, value], index) => (
          <Flex key={index} alignItems={'center'} gap={2}>
            <DoubleField boxSize={5} type={type} />
            <Text mr={1}>{value}</Text>
          </Flex>
        ))}
      </Flex>
    </Box>
  )
}
